export const LAPTOP_WIDTH = "1024px";

export const COLORS = {
  white: "#fff",
  black: "#131314",
  trueBlack: "#000000",
  mofoGreen: "#77b204",
  greenLantern: "#48a90f",
  vader: "#131314",
  darkMofo: "#232627",
  redRedWine: "#9a0945",
  liquidGold: "#d6a871",
  dorianGray: "#626468",
  almostWhite: "#f7f8fa",
  neonGreen: "#cdff6b",
  bubbly: "#fff2d4",
  charlie: "#fca403",
  clockwork: "#ff6d21",
  sunlit: "#fca403",
  deal: "#d51c5c",
  pinky: "#ff62a5",
  mystique: "#1392c5",
  papaSmurf: "#1cb6f4",
  smurfette: "#e0f6ff",
  sparklingRose: "#fdbebf",
  whiteWhiteWine: "#dec8ad",
  newToTheFo: "#77B204",
  popularOffer: "#0055B8",
  oneClickCheckout: "#fba704",
  alto: "#D9D9D9",
  tierGreen: "#77B204",
  tierDarkGreen: "#598504",
  tierSilver: "#A7A7A7",
  tierDarkSilver: "#737373",
  tierGold: "#D6A871",
  tierDarkGold: "#A87C46",
  tierBlack: "#282222",
  tierDarkBlack: "#1a1616",
  mofoGold: "#FCBD58",
  gold: "#F3B659",
};

export const FONT_FAMILIES = {
  text: `"Graphik", sans-serif`,
  heading: `"GT Walsheim", sans-serif`,
  dmSans: `"DM Sans", sans-serif`,
  timmonsNy: `"TIMMONSNY", sans-serif`,
};

export const ALT_COLORS = {
  divider: "#e2e2e2",
  background: "#eaecef",
  disabled: "#d9d9d9",
  fieldBackground: "#f5f7fa",
  fieldBorder: "#c9ccd3",
};

const BASE = 10;
const SPACE_MULTIPLIERS = [0, 1, 1.6, 2, 3, 4];
export const SPACES: Array<string> = SPACE_MULTIPLIERS.map(
  (multiplier) => `${multiplier * BASE}px`
);
